import React, { useEffect, useState } from 'react';

const InstagramCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processando autenticação...');

  useEffect(() => {
    const processCallback = () => {
      try {
        if (!window.opener) {
          setStatus('error');
          setMessage('Esta página deve ser aberta através do popup de autenticação.');
          return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        const messageData = {
          type: 'INSTAGRAM_OAUTH_RESPONSE',
          code: code || undefined,
          error: error || undefined,
          error_description: errorDescription || undefined,
        };

        const targetOrigin = window.location.origin;
        window.opener.postMessage(messageData, targetOrigin);

        if (code) {
          setStatus('success');
          setMessage('Autenticação concluída com sucesso! Esta janela será fechada automaticamente...');
          setTimeout(() => {
            window.close();
          }, 1500);
        } else if (error) {
          setStatus('error');
          setMessage(`Erro: ${errorDescription || error}`);
          setTimeout(() => {
            window.close();
          }, 3000);
        }
      } catch (err) {
        console.error('Erro ao processar callback:', err);
        setStatus('error');
        setMessage('Erro ao processar autenticação.');
      }
    };

    processCallback();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        backgroundColor:
          status === 'success' ? '#f0f9ff' : status === 'error' ? '#fef2f2' : '#ffffff',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '400px' }}>
        {status === 'processing' && (
          <div
            style={{
              width: '48px',
              height: '48px',
              border: '4px solid #e5e7eb',
              borderTopColor: '#3b82f6',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 20px',
            }}
          />
        )}

        {status === 'success' && (
          <div
            style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#10b981',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              color: 'white',
              fontSize: '24px',
            }}
          >
            ✓
          </div>
        )}

        {status === 'error' && (
          <div
            style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#ef4444',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              color: 'white',
              fontSize: '24px',
            }}
          >
            ✕
          </div>
        )}

        <p style={{ fontSize: '16px', color: '#374151', margin: 0 }}>{message}</p>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default InstagramCallback;
